import { useEffect, useRef } from 'react';

const AdBanner = () => {
  const adRef = useRef(null);

  useEffect(() => {
    // Ensure AdSense is loaded and only push if not already pushed
    if (window.adsbygoogle && adRef.current && !adRef.current.getAttribute('data-adsbygoogle-status')) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('Adsbygoogle error:', e);
      }
    }
  }, []);

  return (
    <ins className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client="ca-pub-4596844752264194"
      data-ad-slot="YYYYYYYYY"
      data-ad-format="auto"
      data-full-width-responsive="true">
    </ins>
  );
};

export default AdBanner;
